import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import InitAutoplay from '../../../scripts/initAutoplay.js';
Swiper.use([Navigation, Pagination, Autoplay]);

const reviewsConfig = {
  pagination: {
    el: '.er_reviews_top__inner__pagination',
    clickable: true,
  },
  spaceBetween: 30,
  resizeObserver: true,
  grabCursor: true,
  navigation: {
    nextEl: '.er_reviews_top__inner__next',
    prevEl: '.er_reviews_top__inner__prev',
  },
};

export default () => {
  const reviewsTopSlider = new Swiper('.er_reviews_top_container', reviewsConfig);
  window.addEventListener('scroll', () => {
    InitAutoplay(reviewsTopSlider, 'er_reviews_top', 6000);
  });
};
